import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var MapCursor = styled.g(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  pointer-events: bounding-box;\n\n  g {\n    pointer-events: fill;\n  }\n"], ["\n  cursor: ", ";\n  pointer-events: bounding-box;\n\n  g {\n    pointer-events: fill;\n  }\n"])), function (props) { return props.cursor || 'grab'; });
var templateObject_1;
